import { Badge } from "react-bootstrap";
import useWindowSize from "../../hooks/useWindowSize";

const BadgeEstadoActa = ({ estado }) => {
  const size = useWindowSize();
  const width = size.width;

  return (
    <div>
      {estado?.id ? (
        <Badge
          bg={`${
            estado.id == 5
              ? "warning"
              : estado.id == 9
              ? "secondary"
              : estado.id == 2
              ? "success"
              : estado.id == 8
              ? "dark"
              : estado.id == 3
              ? "danger"
              : "primary"
          }`}
          className={`${estado.id == 5 && "text-dark"}`}
        >
          {/* { width >= 640 ? estado?.estado : estado?.estado.split(' ')[0]} */}
          {estado?.estado.split(" ")[0]}
        </Badge>
      ) : (
        <Badge
          bg={`${
            estado == 5
              ? "warning"
              : estado == 9
              ? "secondary"
              : estado == 10
              ? "primary"
              : estado == 2
              ? "success"
              : estado == 8
              ? "dark"
              : estado == 3
              ? "danger"
              : "primary"
          }`}
          className={`${estado == 5 && "text-dark"} px-4 py-2`}
        >
          <p style={{ fontSize: "18px", padding: "2px 0" }} className=" m-0">
            {estado == 5
              ? "Pendientes de inspeccion"
              : estado == 9
              ? "Incompletas"
              : estado == 2
              ? "Aceptadas"
              : estado == 8
              ? "Finalizadas"
              : estado == 3
              ? "Rechazadas"
              : estado == 10
              ? "Pendientes aceptar"
              : "No elegida"}
          </p>
        </Badge>
      )}
    </div>
  );
};
export default BadgeEstadoActa;
